import React, { useState, useEffect } from 'react';
import toast from "react-hot-toast";
import moment from 'moment';
import {
    Grid,
    Typography,
    IconButton,
    Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import {
    mapAndSort,
    mapAndSortBySpecificKey,
    mapAndSortLocation,
    generateLifeTimeNmberRange,
    generateYearRange,
    yes_no_options,
    initialErrorObjectState,
    initialCylinderState,
    cylinderRequiredFields,
    cylinderTagSerialPair,
    isSubsystem,
    EditableSystemType,
    cylinderFieldsToIgnore,
    assetFieldsToIgnore,
    editCylinderRequiredFields,
    getOilTypeValue,
} from './utils';
import { FormatDate, isMobile } from '../../../src/utils';
import { postRequestHeaders } from '../../../src/utils';
import {
    PrimaryButton,
    SecondaryButton,
    LoadingBar,
    BreadCrumbs,
    CommonModal,
    Select,
    LoadingButtonV4,
    ExitConfirmationModal,
    DeleteModal,
    Error404,
} from '../Common';
import { GetAssetCodes } from "../../CodesCache";
import ControlsControl from './Controls_Control';
import ControlsLeakMonitoringDevice from './Controls_LeakMonitoringDevice';
import Generator from './Generator';
import DieselFirePump from './DieselFirePumps'
import FireExtingusiher from './FireExtinguisher';
import SmokeAlarm from './SmokeAlarm';
import SprinklerHeads from './SprinklerHeads';
import GeneralInventory from './GeneralInventory';
import Heating from './Heating';
import ComfortCooling from './ComfortCooling';
import ProcessCooling from './ProcessCooling';
import GasRecoveryCart from './GasRecoveryCart';
import Cylinder from './Cylinder/index';
import Refrigeration from './Refrigeration';
import GreaseTrap from './GreaseTrap';
import SepticTank from './SepticTank';
// import SewerDrain from './SewerDrain';
// import BackflowPreventer from './BackflowPreventer';
import DecorativeFountain from './DecorativeFountain';
import EyeWashStation from './EyeWashStation';
import PlumbingFixtures from './PlumbingFixtures';
import WaterCoolingTower from './WaterCoolingTower';
import WaterHeaters from './WaterHeaters';
import { useHistory } from 'react-router-dom';
import Routes from '../../routes';
import Enums from "../../enums"
import UserInfo from '../../UserInfo';
import { Grey1, Grey2 } from '../../color_utils';
import { trakrefFontFamily } from '../../../src/utils';
import Subsystem from './Subsystem';
import useBreadCrumbs from '../../hooks/useBreadCrumbs';
import useNavigate from '../../hooks/useNavigate';
import useFormDirty from '../../hooks/useFormDirty';
import { canRecordInstall } from '../Account/utils';

import Validator from '../../Utils/Validator';
import Weight from '../../Utils/Weight';

const AddAsset = ({
    match: {
        params: { id } = {},
    },
    location: {
        state: {
            parentAssetID,
            parentAssetName,
            parentAssetLocationID,
            selectedSubsystemType,
            activeTab,
            activeRowState
        } = {}
    } = {},
}) => {
    const pageHeader = id > 0 ? "Edit Inventory" : "Create Inventory";
    const subSystemHeader = id > 0 ? "Edit Subsystem" : "Create Subsystem";
    const isEditing = !!id;
    const [loading, setLoading] = useState(true);
    const [isAssetNotFound, setIsAssetNotFound] = useState(false);
    const history = useHistory();
    const [cylinderTypes, setCylinderTypes] = useState([]);
    const [assetTypes, setAssetTypes] = useState([]);
    const [assetStatusTypes, setAssetStatusTypes] = useState([]);
    const [locations, setLocations] = useState([]);
    const [subLocations, setSubLocations] = useState([]);
    const [manufacturers, setManufacturers] = useState([]);
    const [allManufacturers, setAllManufacturers] = useState([]);
    const [regulatedAssetTypes, setRegulatedAssetTypes] = useState([]);

    const [materialStatuses, setMaterialStatuses] = useState([]);
    const [materialTypes, setMaterialTypes] = useState([]);
    const [psiRatings, setPsiRatings] = useState([]);
    const [filterSizes, setFilterSizes] = useState([]);
    const [shutoffValveTypes, setShutoffValveTypes] = useState([]);
    const [successfulPopup, setSuccessfulPopup] = useState(false);
    const [isProcessingSubmission, setIsProcessingSubmission] = useState(false);
    const [systemManagers, setSystemManagers] = useState([]);
    const [ErrorObject, setErrorObject] = useState(initialErrorObjectState);
    const [maxDate, setMaxDate] = useState(null);
    const [hasActiveServiceEvent, setHasActiveServiceEvent] = useState();

    // --------- Common Fields --------- \\
    const [assetId, setAssetId] = useState(0);
    const [applianceId, setApplianceId] = useState(0);
    const [coolingApplianceId, setCoolingApplianceId] = useState(0);
    const [location, setLocation] = useState("");
    const [subLocation, setSubLocation] = useState("");
    const [assetType, setAssetType] = useState("");
    const [aquireLocationOptions, setAquireLocations] = useState("")
    const [aquireLocation, setAquireLocation] = useState("")
    const [assetCategory, setAssetCategory] = useState("");
    const [name, setName] = useState("");
    const [assetStatus, setAssetStatus] = useState("");
    const [tagNumber, setTagNumber] = useState("");
    const [serialNumber, setSerialNumber] = useState("");
    const [acquisitionDate, setAquisitionDate] = useState("");
    const [disbursementDate, setDisbursementDate] = useState("");
    const [installDate, setInstallDate] = useState("");
    const [locationOnSite, setLocationOnsite] = useState("");
    const [certificationDate, setCertificationDate] = useState("")
    const [manufacturer, setManufacturer] = useState("");
    const [manufactureDate, setManufactureDate] = useState("");
    const [modelNumber, setModelNumber] = useState("");
    const [modelYear, setModelYear] = useState("");
    const [brand, setBrand] = useState("");
    const [poNumber, setPONumber] = useState("");
    const [lifeTime, setLifeTime] = useState("");
    const [lifeTimeOptions, setLifeTimeOptions] = useState([]);
    const [years, setYears] = useState([]);
    const [systemType, setSystemType] = useState("");
    const [generatorType, setGeneratorType] = useState("");
    const [generatorSubtype, setGeneratorSubtype] = useState("");
    const [materialStatus, setMaterialStatus] = useState("");
    const [assetSubtype, setAssetSubtype] = useState(null);
    const [assetKind, setAssetKind] = useState(null);
    const [regulatedAssets, setRegulatedAssets] = useState([-1]);

    // --------- Common Fields --------- \\

    // --------- Controls - Control --------- \\
    const [newPurchaseAquisition, setNewPurchaseAquisition] = useState("");

    // --------- Controls - Leak Monitoring Device --------- \\
    const [deviceType, setDeviceType] = useState("");
    const [aldType, setALDType] = useState("");
    const [detectionLimit, setDetectionLimit] = useState("");
    const [alarmPoint, setAlarmPoint] = useState("");
    const [concentrationMonitorType, setConcentrationMonitorType] = useState("");
    const [concentrationMonitorManufacturer, setConcentrationMonitorManufacturer] = useState("");
    const [sensorType, setSensorType] = useState("");
    const [numberOfSensors, setNumberOfSensors] = useState("")
    const [amps, setAmps] = useState("");
    const [voltage, setVoltage] = useState("");
    const [hertz, setHertz] = useState("");
    const [phase, setPhase] = useState("");
    const [systemManager, setSystemManager] = useState("");
    const [hermeticallySealed, setHermeticallySealed] = useState(null);
    const [energySourceType, setEnergySourceType] = useState("");

    // --------- Fire Suppresion Systems --------- \\
    const [maxSuctionPressure, setMaxSuctionPressure] = useState("");
    const [driverManufacturer, setDriverManufacturer] = useState("");
    const [pumpModelNumber, setPumpModelNumber] = useState("");
    const [maxShutoffPressure, setMaxShutoffPressure] = useState("");
    const [driverModelNumber, setDriverModelNumber] = useState("");
    const [pumpSerialNumber, setPumpSerialNumber] = useState("");
    const [ratedCapacity, setRatedCapacity] = useState("");
    const [driverRatedRPM, setDriverRatedRPM] = useState("");
    const [ratedRPM, setRatedRPM] = useState("");
    const [ratedPressure, setRatedPressure] = useState("");
    const [fuelTankCapacity, setFuelTankCapacity] = useState("");
    const [controllerManufacturer, setControllerManufacturer] = useState("");
    const [oneFiftyRatedCapacity, setOneFiftyRatedCapacity] = useState("");
    const [controllerModelNumber, setControllerModelNumber] = useState("");
    const [ratedPressureAtCapacity, setRatedPressureAtCapacity] = useState("");
    const [controllerSerialNumber, setControllerSerialNumber] = useState("");
    const [materialType, setMaterialType] = useState("");
    const [smokeAlarmSubtype, setSmokeAlarmSubtype] = useState("");
    const [sprinklerHeads, setSprinklerHeads] = useState("");

    // --------- Heating Systems --------- \\
    const [heatingType, setHeatingType] = useState("");
    const [systemStatus, setSystemStatus] = useState("");
    const [currentGasWeightLBS, setCurrentGasWeightLBS] = useState(null);
    const [currentGasWeightOZ, setCurrentGasWeightOZ] = useState(null);
    const [ratedCoilTemperature, setRatedCoilTemperature] = useState("");
    const [chargeCapacityLBS, setChargeCapacityLBS] = useState(null);
    const [chargeCapacityOZ, setChargeCapacityOZ] = useState(null);
    const [chargeCapacityDeterminedBy, setChargeCapacityDeterminedBy] = useState("");
    const [temperatureClass, setTemperatureClass] = useState("");
    const [coolingCapacity, setCoolingCapacity] = useState("");
    const [SEER, setSEER] = useState("");
    const [EER, setEER] = useState("");
    const [ESEER, setESEER] = useState("");
    const [oilType, setOilType] = useState("");
    const [alternateLeakDetectionMethod, setAlternateLeakDetectionMethod] = useState(null);
    const [leakDetectionDetails, setLeakDetectionDetails] = useState("");

    // --------- Comfort Cooling --------- \\
    const [comfortCoolingType, setComfortCoolingType] = useState("");
    const [comfortCoolingSubtype, setComfortCoolingSubtype] = useState("");
    const [comfortCoolingSubOptions, setComfortCoolingSubOptions] = useState([]);
    const [leakMonitorDevice, setLeakMonitorDevice] = useState(null);

    // --------- Gas Recovery Cart --------- \\
    const [selfContained, setSelfContained] = useState("");
    const [certificationNotes, setCertificationNotes] = useState("");
    const [gasRecoveryCartId, setGasRecoveryCartId] = useState("");

    // --------- Process Cooling --------- \\
    const [processCoolingType, setProcessCoolingType] = useState("");
    const [processCoolingSubType, setProcessCoolingSubType] = useState("")
    const [ultraLowFreezerType, setUltraLowFreezerType] = useState("");

    // --------- Cylinders --------- \\
    const [cylinderStatus, setCylinderStatus] = useState("");
    const [maxGasCapacity, setMaxGasCapacity] = useState("");
    const [dotExpirationDate, setDotExpirationDate] = useState("");
    const [psiRating, setPSIRating] = useState("");
    const [currentPSI, setCurrentPSI] = useState("");
    const [boughtRented, setBoughtRented] = useState("");

    // --------- Refrigeration Cooling --------- \\
    const [refigerationtCoolingType, setRefrigerationCoolingType] = useState("");
    const [extraOptions, setExtraOptions] = useState([]);
    const [refrigerationSubtype, setRefrigerationSubtype] = useState("");

    // --------- Septic Tank --------- \\
    const [septicTankType, setSepticTankType] = useState("");

    // --------- Backflow Preventer --------- \\
    const [backflowPreventerType, setBackflowPreventerType] = useState("");
    const [backflowPreventerType2, setBackflowPreventerType2] = useState("");
    const [installationDate, setInstallationDate] = useState("");
    const [filterSize, setFilterSize] = useState("");
    const [oritentationType, setOritentationType] = useState("");
    const [waterOrigin, setWaterOrigin] = useState("");
    const [shutoffValveType, setShutoffValveType] = useState("");

    // --------- Plumbing / Fixtures --------- \\
    const [plumbingFixtureType, setPlumbingFixtureType] = useState("");
    const [plumbingFixtureSubtypes, setPlumbingFixtureSubtypes] = useState("");

    // --------- Water Cooling Tower Type --------- \\
    const [waterCoolingTowerType, setWaterCoolingTowerType] = useState("");
    const [waterCoolingTowerTypeSubOption, setWaterCoolingTowerTypeSubOption] = useState("")

    // --------- Water Heater Type --------- \\
    const [waterHeatersType, setWaterHeatersType] = useState("");
    const [waterHeaterSubtype, setWaterHeaterSubtype] = useState("");
    const [capacityGallons, setCapacityGallons] = useState("");
    const [waterHeaterType, setWaterHeaterType] = useState("");
    const [exitModal, setExitModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // ****** Rapid Cylinder Entry ****** \\
    // *********************************** \\
    const [cylinderState, setNewCylinderState] = useState({
        cylinders: [{ ...initialCylinderState, location: parentAssetLocationID ? parentAssetLocationID : "", cylinderRequiredFields, cylinderTagSerialPair }],
        loading: false,
    });

    const [cylinderErrorState, setNewCylinderErrorState] = useState({
        cylinders: [{ id: null }]
    });

    const navigate = useNavigate({
        pageName: 'AddAsset'
    });
    const breadCrumb = useBreadCrumbs({
        path: { id: 'AddAsset', text: id ? 'Edit' : 'Create Inventory', link: history.location.pathname, shouldBeReplaced: !id }
    });
    const { initializeData, isDirty } = useFormDirty();

    const setCylinderState = (new_cylinder_state) => (
        setNewCylinderState(prevState => ({
            ...prevState,
            ...new_cylinder_state
        }))
    );

    const setCylinderErrorState = (new_error_obj) => (
        setNewCylinderErrorState(prevState => ({
            ...prevState,
            ...new_error_obj,
        }))
    );

    const isVirginOrRecoveryCylinder = [
        Enums.AssetTypes.VirginCylinder,
        Enums.AssetTypes.RecoveryCylinder
    ].includes(assetType);

    const mapServerValidationErrorsToFields = (errors = []) => {
        const fieldErrors = {};
        const globalErrors = [];
        const errorList = Array.isArray(errors) ? errors : [errors];

        errorList.forEach(error => {
            const message = error?.exceptionMessage || error?.ExceptionMessage || error?.message || "";
            const normalizedMessage = message.toLowerCase();

            if (!message) return;

            if (normalizedMessage.includes("tag number")) {
                fieldErrors.TagNumber = message;
                return;
            }

            if (normalizedMessage.includes("serial number")) {
                fieldErrors.SerialNumber = message;
                return;
            }

            if (normalizedMessage.includes("name must be unique")) {
                fieldErrors.Name = message;
                return;
            }

            if (normalizedMessage.includes("material type")) {
                fieldErrors.MaterialType = message;
                return;
            }

            if (
                normalizedMessage.includes("maxgascapacity") ||
                normalizedMessage.includes("over-charge") ||
                normalizedMessage.includes("charge capacity") ||
                normalizedMessage.includes("current gas weight")
            ) {
                fieldErrors.CurrentGasWeightLBS = message;
                fieldErrors.ChargeCapacity = message;
                return;
            }

            globalErrors.push(message);
        });

        return { fieldErrors, globalErrors };
    };

    const renderSecondaryButton = (
        !id
        && !isSubsystem(assetType)
    );

    const renderDeleteButton = (
        id && !hasActiveServiceEvent &&
        (
            UserInfo.isSystemAdministrator() ||
            (UserInfo.isNativeSystemOwner() &&
                (
                    UserInfo.isSuperTenantAdmin() ||
                    UserInfo.isTenantAdministrator() ||
                    UserInfo.isRegionalAdministrator()
                )
            )
        )
    );
    // ************************************************************ \\
    // ************************************************************ \\

    const resetCommonFields = () => {
        // if there's preset location ID, do not reset location field
        if (!parentAssetLocationID) setLocation("");
        setSubLocation("");
        setAquireLocation("");
        setName("");
        // Default value to 'Active' in form field for creating an asset
        setAssetStatus(!id ? 1 : "");
        setTagNumber("");
        setSerialNumber("");
        setAquisitionDate("");
        setDisbursementDate("");
        setInstallDate("");
        setLocationOnsite("");
        setCertificationDate("");
        setManufacturer("");
        setManufactureDate("");
        setModelNumber("");
        setModelYear("");
        setBrand("");
        setPONumber("");
        setLifeTime("");
        setSystemType("");
        setGeneratorType("");
        setGeneratorSubtype("");
        setMaterialStatus("");
        setAssetSubtype(null);
        setAssetKind(null);
        setRegulatedAssets([-1]);
    };

    const resetControlField = () => {
        setNewPurchaseAquisition("");
    };

    const resetLeakMonitoringDeviceField = () => {
        setDeviceType("");
        setALDType("");
        setDetectionLimit("");
        setAlarmPoint("");
        setConcentrationMonitorType("");
        setConcentrationMonitorManufacturer("");
        setSensorType("");
        setNumberOfSensors("");
        setAmps("");
        setVoltage("");
        setHertz("");
        setPhase("");
        setSystemManager("");
        setHermeticallySealed("");
        setEnergySourceType("");
    };

    const resetFireSuppressionSystemsField = () => {
        setMaxSuctionPressure("");
        setDriverManufacturer("");
        setPumpModelNumber("");
        setMaxShutoffPressure("");
        setDriverModelNumber("");
        setPumpSerialNumber("");
        setRatedCapacity("");
        setDriverRatedRPM("");
        setRatedRPM("");
        setRatedPressure("");
        setFuelTankCapacity("");
        setControllerManufacturer("");
        setOneFiftyRatedCapacity("");
        setControllerModelNumber("");
        setRatedPressureAtCapacity("");
        setControllerSerialNumber("");
        setMaterialType("");
        setSmokeAlarmSubtype("");
        setSprinklerHeads("");
    };

    const resetHeatingSystemsField = () => {
        setHeatingType("");
        // Default value to 'Normal Operation' in form field for creating an asset
        setSystemStatus(!id ? 1 : "");
        setCurrentGasWeightLBS(null);
        setCurrentGasWeightOZ(null);
        setRatedCoilTemperature("");
        setChargeCapacityLBS(null);
        setChargeCapacityOZ(null);
        setChargeCapacityDeterminedBy("");
        setTemperatureClass("");
        setCoolingCapacity("");
        setSEER("");
        setEER("");
        setESEER("");
        setOilType("");
        setAlternateLeakDetectionMethod(null);
        setLeakDetectionDetails("");
    };

    const resetComfortCoolingField = () => {
        setComfortCoolingType("");
        setComfortCoolingSubtype("");
        setComfortCoolingSubOptions([]);
        setLeakMonitorDevice(null);
    };

    const resetGasRecoveryCartField = () => {
        setSelfContained("");
        setCertificationNotes("");
        setGasRecoveryCartId("");
    };

    const resetProcessCoolingField = () => {
        setProcessCoolingType("");
        setProcessCoolingSubType("");
        setUltraLowFreezerType("");
    };

    const resetCylindersField = () => {
        setCylinderStatus("");
        setMaxGasCapacity("");
        setDotExpirationDate("");
        setPSIRating("");
        setCurrentPSI("");
        setBoughtRented("");
        setNewCylinderErrorState({ cylinders: [{ id: null }] });
    };

    const resetRefrigerationCoolingField = () => {
        setRefrigerationCoolingType("");
        setExtraOptions([]);
        setRefrigerationSubtype("");
    };

    const resetSepticTankField = () => {
        setSepticTankType("");
    };

    const resetBackflowPreventerField = () => {
        setBackflowPreventerType("");
        setBackflowPreventerType2("");
        setInstallationDate("");
        setFilterSize("");
        setOritentationType("");
        setWaterOrigin("");
        setShutoffValveType("");
    };

    const resetPlumbingFixturesField = () => {
        setPlumbingFixtureType("");
        setPlumbingFixtureSubtypes("");
    };

    const resetWaterCoolingTowerTypeField = () => {
        setWaterCoolingTowerType("");
        setWaterCoolingTowerTypeSubOption("");
    };

    const resetWaterHeaterType = () => {
        setWaterHeaterType("");
        setWaterHeatersType("");
        setWaterHeaterSubtype("");
        setCapacityGallons("");
        setExitModal(false);
    };

    const resetFields = () => {
        if (!id && !parentAssetID) {
            resetCommonFields();
            resetControlField();
            resetLeakMonitoringDeviceField();
            resetFireSuppressionSystemsField();
            resetHeatingSystemsField();
            resetComfortCoolingField();
            resetGasRecoveryCartField();
            resetProcessCoolingField();
            resetCylindersField();
            resetRefrigerationCoolingField();
            resetSepticTankField();
            resetBackflowPreventerField();
            resetPlumbingFixturesField();
            resetWaterCoolingTowerTypeField();
            resetWaterHeaterType();
            setErrorObject({});
        } else if (EditableSystemType.includes(assetType) && id) {
            //set asset subtype and asset kind to null when update assetType to ComfortCooling|ProcessCooling|Refrigeration
            setAssetSubtype(null);
            setAssetKind(null);
        }
    };

    const renderWeight = (weightValue) => {
        if (isNaN(weightValue)) return;

        if (UserInfo.weightUnits === 'Lbs') {
            return Number(weightValue.toFixed(2));
        }

        const kg = 0.453592;
        return Number((weightValue * kg).toFixed(2));
    }

    let today = new Date();

    // #15388: "Save Installed" commissions a system without an Install event, so it follows the Install rule (server enforces the same)
    const canSaveInstalled = (
        (
            UserInfo.isSystemAdministrator()
            || UserInfo.isNativeSuperTenantAdministrator()
            || UserInfo.isNativeTenantAdministrator()
            || UserInfo.isNativeRegionalAdministrator()
        )
        && canRecordInstall()
    );

    useEffect(() => {
        today.setHours(0, 0, 0, 0);
        fetchData();
        setMaximumDate();
    }, []);

    useEffect(() => {
        const Manufacturers = GetManufacturers(allManufacturers, assetType);
        const sortedManufacturers = mapAndSort(Manufacturers);
        setManufacturers(sortedManufacturers);
    }, [assetType]);

    useEffect(() => {
        if (assetStatus == 1) { // if assetStatus is active
            setDisbursementDate(null)
        }
    }, [assetStatus])

    const GetManufacturers = (manufacturers, type) => {
        if (type === Enums.AssetTypes.RecoveryCylinder || type === Enums.AssetTypes.VirginCylinder) {
            return manufacturers.filter(e => e.isCylinder);
        }
        if (type === Enums.AssetTypes.BackflowPreventer) {
            return manufacturers.filter(e => e.isBackflowPreventer);
        }
        return manufacturers;
    };

    const computeClass = (obj) => {
        if (obj.enabled == true || obj.name.toLowerCase() === "r-404" || obj.name.toLowerCase() === "r-410") {
            if (obj.class === 'Class FR') {
                return obj.class
            } else {
                return ""
            }
        } else {
            return "Bad"
        }
    };

    const fetchData = async () => {
        const lifeYears = await generateLifeTimeNmberRange();
        const modelYears = await generateYearRange();
        const data = await GetAssetDropdownCodes();
        const cachedata = await GetAssetCodes();
        const sortedLocations = mapAndSortLocation(data.locations);
        let assetTypes = data.assetTypes;
        let MaterialTypesFiltered = cachedata.materialTypes.filter((obj) => obj.accountTypeId != 16 && (obj.id == 82 || computeClass(obj) == ''));

        assetTypes = assetTypes.filter(f =>
            f.id === Enums.AssetTypes.ControlsControl ||
            f.id === Enums.AssetTypes.ComfortCooling ||
            f.id === Enums.AssetTypes.VirginCylinder ||
            f.id === Enums.AssetTypes.RecoveryCylinder ||
            f.id === Enums.AssetTypes.Refrigeration ||
            f.id === Enums.AssetTypes.ProcessCooling ||
            f.id === Enums.AssetTypes.GasRecoveryCart ||
            f.id === Enums.AssetTypes.CompressorRack ||
            f.id === Enums.AssetTypes.Condensor ||
            f.id === Enums.AssetTypes.Evaporator ||
            f.id === Enums.AssetTypes.LeakMonitoringDevice
        );

        if (parentAssetID) {
            assetTypes = assetTypes.filter(f =>
                f.id === Enums.AssetTypes.CompressorRack ||
                f.id === Enums.AssetTypes.Condensor ||
                f.id === Enums.AssetTypes.Evaporator
            );
        } else if (!id) {
            // Filter these options out only when create new asset
            // When edit asset we keep these options in dropdown so the loaded asset type will be shown
            assetTypes = assetTypes.filter(f =>
                f.id === Enums.AssetTypes.ControlsControl ||
                f.id === Enums.AssetTypes.ComfortCooling ||
                f.id === Enums.AssetTypes.VirginCylinder ||
                f.id === Enums.AssetTypes.RecoveryCylinder ||
                f.id === Enums.AssetTypes.Refrigeration ||
                f.id === Enums.AssetTypes.ProcessCooling ||
                f.id === Enums.AssetTypes.GasRecoveryCart ||
                f.id === Enums.AssetTypes.LeakMonitoringDevice
            );
        }


        if (isMobile) {
            assetTypes = assetTypes.filter(f =>
                f.id === Enums.AssetTypes.VirginCylinder ||
                f.id === Enums.AssetTypes.RecoveryCylinder ||
                f.id === Enums.AssetTypes.Refrigeration ||
                f.id === Enums.AssetTypes.ProcessCooling ||
                f.id === Enums.AssetTypes.GasRecoveryCart ||
                f.id === Enums.AssetTypes.LeakMonitoringDevice
            );
        }


        const sortedManufacturers = mapAndSort(data.manufacturers);
        const sortedStatuses = mapAndSort(data.materialStatuses);
        const sortedTypes = mapAndSort(MaterialTypesFiltered)
        const sortedPSI = mapAndSort(data.psiRatings);
        const sortedFilterSizeTypes = mapAndSortBySpecificKey(data.filterSizeTypes, "filterSize");
        const sortedShutoffValveTypes = mapAndSortBySpecificKey(data.shutOffValveTypes, "shutOffValveName");
        const aquireLocations = mapAndSort(data.aquireLocations);

        setAssetTypes(assetTypes);
        setAquireLocations(aquireLocations)
        setLifeTimeOptions(lifeYears);
        setYears(modelYears);
        setLocations(sortedLocations);
        setAllManufacturers(data.manufacturers)
        setManufacturers(sortedManufacturers);
        setCylinderTypes(data.cylinderTypes);
        setMaterialTypes(sortedTypes);
        setMaterialStatuses(sortedStatuses);
        setPsiRatings(sortedPSI);
        setFilterSizes(sortedFilterSizeTypes);
        setShutoffValveTypes(sortedShutoffValveTypes);
        setAssetStatusTypes(cachedata.assetStatus);
        setSystemManagers(data.systemManagers);
        console.log({
            regulatedAssetTypes: data.regulatedAssetTypes
        })
        setRegulatedAssetTypes(data.regulatedAssetTypes);

        if (id) {
            setAssetId(id);
            const responseAsset = await fetch(Routes.Asset.Details(id));
            const dataAsset = await responseAsset.json();

             if (dataAsset.status === 404) {
                setIsAssetNotFound(true);
                setLoading(false);
                return;
            }

            if (UserInfo.isRegionalAdministrator()
                && !UserInfo.canServiceLocation(dataAsset.location, dataAsset.instanceId)) {
                setIsAssetNotFound(true);
                setLoading(false);
                return;
            }

            const { assetType = null } = dataAsset;
            setHasActiveServiceEvent(dataAsset.hasActiveServiceEvent);

            if ([Enums.AssetTypes.VirginCylinder, Enums.AssetTypes.RecoveryCylinder].includes(assetType)) {
                const cylinderData = mapCylinderData(dataAsset, sortedLocations, true);
                initializeData(cylinderData, cylinderFieldsToIgnore);
            } else {
                mapToAsset(dataAsset);
                initializeData(dataAsset, assetFieldsToIgnore);
            }
            if (assetType === Enums.AssetTypes.ComfortCooling
                || assetType === Enums.AssetTypes.ProcessCooling
                || assetType === Enums.AssetTypes.Refrigeration) {
                assetTypes = assetTypes.filter(f =>
                    f.id === Enums.AssetTypes.ComfortCooling ||
                    f.id === Enums.AssetTypes.ProcessCooling ||
                    f.id === Enums.AssetTypes.Refrigeration
                );
                setAssetTypes(assetTypes);
            }
        } else if (parentAssetLocationID) {
            setLocation(parentAssetLocationID);
            setAssetType(selectedSubsystemType);

            const assetType = assetTypes.find(f => f.id === selectedSubsystemType);
            if (assetType) {
                setAssetCategory(assetType.assetCategoryId);
            }
        }

        setLoading(false);
    };

    const setMaximumDate = () => {
        const today = new Date();
        const max_date = today.setDate(today.getDate() - 1);
        setMaxDate(max_date);
    };

    const validateFields = (isSaveInstalled) => {
        const errorObject = {};
        setErrorObject(errorObject);
        let isValid = true;
        console.log('isSaveInstalled', isSaveInstalled);
        const isManufacturDateValid = Validator.CheckDate(manufactureDate);
        const isAcquisitionDateValid = Validator.CheckDate(acquisitionDate);
        const isInstallDateValid = Validator.CheckDate(installDate);

        // handle a case where dateformat from database are different from dateinput component
        const formattedManufactureDate = moment(manufactureDate);
        const formattedAcquisitionDate = moment(acquisitionDate);
        const formattedInstallDate = moment(installDate);

        if (location === '' || location === null) {
            errorObject.location = true
        }

        if ((tagNumber === '' || tagNumber == null) && (serialNumber === '' || serialNumber == null)) {
            errorObject.TagNumber = true;
            errorObject.SerialNumber = true
        }

        if (assetStatus === '' || assetStatus === null) {
            errorObject.AssetStatus = true
        }

        if (isSubsystem(assetType) &&
            (assetStatus === Enums.SE.AssetStatus.Decomissioned) && !disbursementDate
        ) {
            errorObject.DisbursementDate = true;
        }

        if (assetType !== Enums.AssetTypes.VirginCylinder
            && assetType !== Enums.AssetTypes.RecoveryCylinder
        ) {
            if (isManufacturDateValid) {
                if ((isInstallDateValid && formattedManufactureDate.isAfter(formattedInstallDate)) ||
                    (isAcquisitionDateValid && formattedManufactureDate.isAfter(formattedAcquisitionDate))) {
                    errorObject.ManufactureDate = "Manufacture date cannot be after Install / Acquisition Date";
                }
            } else {
                if (manufactureDate && isManufacturDateValid === false) {
                    errorObject.ManufactureDate = 'Please enter a valid date.';
                }
            }

            if (installDate && isInstallDateValid === false) {
                errorObject.InstallDate = 'Please enter a valid date.';
            }
            if (acquisitionDate && isAcquisitionDateValid === false) {
                errorObject.AcquisitionDate = 'Please enter a valid date.';
            }

            if (name === '' || name === null) {
                errorObject.Name = true
            }
        }

        if (assetType === Enums.AssetTypes.ComfortCooling
            || assetType === Enums.AssetTypes.ProcessCooling
            || assetType === Enums.AssetTypes.Refrigeration
        ) {
            if (chargeCapacityLBS === '' || chargeCapacityLBS === null) {
                errorObject.ChargeCapacity = true;
            }
            if (temperatureClass === '' || temperatureClass === null) {
                errorObject.TemperatureClass = true;
            }
            if (chargeCapacityDeterminedBy === '' || chargeCapacityDeterminedBy === null) {
                errorObject.ChargeCapacityDeterminedBy = true;
            }
            if (systemStatus === '' || systemStatus === null) {
                errorObject.SystemStatus = true;
            }
            if (materialType === '' || materialType === null) {
                errorObject.MaterialType = true;
            }
            if (isNaN(currentGasWeightLBS) || currentGasWeightLBS === undefined || currentGasWeightLBS < 0) {
                errorObject.CurrentGasWeightLBS = true;
            }
            else if (chargeCapacityLBS > 0 && (currentGasWeightLBS > chargeCapacityLBS)) {
                errorObject.CurrentGasWeightLBS =
                    `Current Gas Weight (${renderWeight(currentGasWeightLBS)} ${UserInfo.weightUnits}) must be less than or equal to Charge Capacity (${renderWeight(chargeCapacityLBS)} ${UserInfo.weightUnits})`;
            }
            if (isInstallDateValid === true && isAcquisitionDateValid === true) {
                if (formattedInstallDate.isBefore(formattedAcquisitionDate)) {
                    errorObject.InstallDate = "Install Date cannot be before Acquisition Date.";
                }
            } else {
                if (installDate && isInstallDateValid === false) {
                    errorObject.InstallDate = 'Please enter a valid date.';
                }
                if (acquisitionDate && isAcquisitionDateValid === false) {
                    errorObject.AcquisitionDate = 'Please enter a valid date.';
                }
            }
        }

        if (!isEditing) {
            if (acquisitionDate === null || acquisitionDate === "") {
                errorObject.AcquisitionDate = "This field is required";
            }
            if (installDate === null || installDate === "") {
                errorObject.InstallDate = "This field is required";
            }
        }

        if (assetType === Enums.AssetTypes.LeakMonitoringDevice) {
            if (assetStatus === '' || assetStatus === null) {
                errorObject.AssetStatus = true;
            }

            // we may require these fields at some point in the future
            /* if (manufacturer === '' || manufacturer === null) {
                errorObject.Manufacturer = true;
            }
            if (modelNumber === '' || modelNumber === null) {
                errorObject.ModelNumber = true;
            }
            if (modelYear === '' || modelYear === null) {
                errorObject.ModelYear = true;
            } */

            if (deviceType === '' || deviceType === null) {
                errorObject.DeviceType = true;
            }
        }

        if (assetType === Enums.AssetTypes.GasRecoveryCart) {
            if (selfContained === '' || selfContained === null) {
                errorObject.SelfContained = true;
            }
        }

        try {
            const filteredLocation = locations.filter((obj) => obj.value === location)[0];
            var isCali = filteredLocation && 'state' in filteredLocation && filteredLocation.state === 'CA';
            if (isCali === true
                && assetType !== Enums.AssetTypes.GasRecoveryCart
                && !isSubsystem(assetType)
                && assetType !== Enums.AssetTypes.LeakMonitoringDevice) {
                if (modelYear === '' || modelYear === null) {
                    errorObject.ModelYear = true;
                }
                if (modelNumber === '' || modelNumber === null) {
                    errorObject.ModelNumber = true;
                }
                if (manufacturer === '' || manufacturer === null) {
                    errorObject.Manufacturer = true;
                }
                if (locationOnSite === '' || locationOnSite === null) {
                    errorObject.LocationOnSite = true;
                }
            }
        } catch (error) { console.log('Error', error); }

        if (newPurchaseAquisition === 0 &&
            (aquireLocation === "" || aquireLocation === null) &&
            assetType != Enums.AssetTypes.Condensor &&
            assetType != Enums.AssetTypes.Evaporator &&
            assetType != Enums.AssetTypes.CompressorRack
        ) {
            errorObject.AquireLocation = true;
        }

        setErrorObject(errorObject);

        if (Object.values(errorObject).some(state => state == true || typeof state == 'string')) {
            isValid = false;
        }
        console.log('errors for creating this asset', errorObject);
        return isValid;
    };

    const validateCylinderFields = () => {
        console.log('Cylinders', cylinderState.cylinders);
        const badValues = [undefined, null, ""];
        setCylinderErrorState({});
        const errors = { cylinders: [] };
        let errorExists = false;

        cylinderState.cylinders.forEach((cylinder, index) => {
            cylinder.cylinderRequiredFields.forEach(required_field => {

                const isBadValue = required_field === "newPurchaseAquisition" ? [undefined, null, ""].includes(cylinder[required_field]) : badValues.includes(cylinder[required_field]);

                if (isBadValue) {
                    errorExists = true;
                    if (errors.cylinders[index]) {
                        return errors.cylinders[index][required_field] = true;
                    }
                    return errors.cylinders[index] = { [required_field]: true };
                }
            });

            // Compare gas weight with cylinder capacity here
            if (!isNaN(cylinder['currentGasWeightLBS']) && !isNaN(cylinder['maxGasCapacity'])) {
                if (cylinder['currentGasWeightLBS'] > cylinder['maxGasCapacity']) {
                    errorExists = true;
                    if (errors.cylinders[index]) {
                        errors.cylinders[index]['currentGasWeightLBS'] =
                            `Current Gas Weight ${renderWeight(cylinder['currentGasWeightLBS'])} ${UserInfo.weightUnits} must be less than or equal to Charge Capacity ${renderWeight(cylinder['maxGasCapacity'])} ${UserInfo.weightUnits}`;
                    }
                    errors.cylinders[index] = {
                        'currentGasWeightLBS': `Current Gas Weight ${renderWeight(cylinder['currentGasWeightLBS'])} ${UserInfo.weightUnits} must be less than or equal to Charge Capacity ${renderWeight(cylinder['maxGasCapacity'])} ${UserInfo.weightUnits}`
                    };
                }
            }

            if (cylinder['acquisitionDate'] && Validator.CheckDate(cylinder['acquisitionDate']) === false) {
                errorExists = true;
                if (errors.cylinders[index]) {
                    errors.cylinders[index]['acquisitionDate'] = 'Please enter a valid date.';
                } else {
                    errors.cylinders[index] = {
                        'acquisitionDate': 'Please enter a valid date.'
                    };
                }
            }

            const hasTagSerialError = cylinder.cylinderTagSerialPair.every(field => {
                return badValues.includes(cylinder[field]);
            });

            if (hasTagSerialError) {
                cylinder.cylinderTagSerialPair.forEach(field => {
                    errorExists = true;
                    if (errors.cylinders[index]) {
                        errors.cylinders[index][field] = true;
                    } else {
                        errors.cylinders[index] = { [field]: true };
                    }
                });
            }
        });

        // Check for duplicate values within form (tagNumber, serialNumber)
        const checkDuplicates = (field, msg) => {
            const seen = {};
            cylinderState.cylinders.forEach((cyl, idx) => {
                const val = cyl[field]?.trim().toLowerCase();
                if (val && seen[val] !== undefined) {
                    errorExists = true;
                    errors.cylinders[seen[val]] = { ...errors.cylinders[seen[val]], [field]: msg };
                    errors.cylinders[idx] = { ...errors.cylinders[idx], [field]: msg };
                } else if (val) {
                    seen[val] = idx;
                }
            });
        };
        checkDuplicates('tagNumber', 'Duplicate Tag Number');
        checkDuplicates('serialNumber', 'Duplicate Serial Number');

        console.log('cylinder errors before saving', errors);
        setCylinderErrorState(errors);
        return errorExists;
    };

    const handleCylinderSubmit = async (isSaveInstall) => {
        const errorsExist = validateCylinderFields();
        console.log('cylinders - errorsExist', errorsExist);

        if (errorsExist) {
            toast.error('Please review the form for missing or incorrect fields', { duration: 6000 });
            return null;
        }

        setIsProcessingSubmission(true);

        const postCylinder = async (cylinder, index) => (
            fetch(Routes.Asset.CreateAsset(), {
                method: 'POST',
                headers: { ...postRequestHeaders },
                body: JSON.stringify(cylinder)
            })
                .then(async (response) => {
                    const id = await Promise.resolve(response.json());
                    if (!response.ok) {
                        throw { index, errors: id };
                    }
                    return id;
                })
        );

        const handleCylinderSuccess = (res) => {
            if (id) {
                toast.success('The inventory has been successfully edited.', { duration: 6000 });
            }
            else {
                if (res && res.length === 1) {
                    const newAssetId = res[0];
                    setAssetId(newAssetId);
                    setIsProcessingSubmission(false);
                    return setSuccessfulPopup(true);
                }

                toast.success('Cylinders sucessfully created.', { duration: 6000 });
            }

            return navigate.goBack('/Inventory');
        };

        const promiseArray = cylinderState.cylinders.map((cylinder, index) => postCylinder({
            ...cylinder,
            assetType,
            assetCategory: cylinder.assetCategory || assetCategory,
            RequireInstall: isSaveInstall == true ? false : true,
            regulatedAssetTypes: regulatedAssetTypes.filter(x => cylinder.regulatedAssets.filter(ra => ra !== -1).includes(x.value)).map(x => ({
                id: x.value,
                name: x.name
            })),
        }, index));

        await Promise
            .all(promiseArray)
            .then(res => handleCylinderSuccess(res))
            .catch((err) => {
                console.log('Error creating cylinder', err);
                setIsProcessingSubmission(false);
                const errors = err?.errors;
                const { fieldErrors, globalErrors } = mapServerValidationErrorsToFields(errors);
                const cylinderErrors = {};

                if (fieldErrors.TagNumber) {
                    cylinderErrors.tagNumber = fieldErrors.TagNumber;
                }
                if (fieldErrors.SerialNumber) {
                    cylinderErrors.serialNumber = fieldErrors.SerialNumber;
                }
                if (fieldErrors.MaterialType) {
                    cylinderErrors.materialType = fieldErrors.MaterialType;
                }
                if (fieldErrors.CurrentGasWeightLBS || fieldErrors.ChargeCapacity) {
                    cylinderErrors.currentGasWeightLBS = fieldErrors.CurrentGasWeightLBS || fieldErrors.ChargeCapacity;
                }

                if (Object.keys(cylinderErrors).length > 0 && err?.index !== undefined) {
                    setCylinderErrorState({
                        cylinders: cylinderState.cylinders.map((_, index) => (
                            index === err.index ? {
                                ...(cylinderErrorState.cylinders[index] || {}),
                                ...cylinderErrors
                            } : (cylinderErrorState.cylinders[index] || {})
                        ))
                    });
                }

                if (globalErrors.length > 0) {
                    globalErrors.forEach(message => toast.error(message, { duration: 6000 }));
                } else if (Object.keys(cylinderErrors).length === 0) {
                    toast.error('An error occurred creating the cylinders. Please try again.', { duration: 6000 });
                }
            });
    };

    const submit = async (isSaveInstall) => {

        if (isVirginOrRecoveryCylinder) {
            return handleCylinderSubmit(isSaveInstall);
        }

        setIsProcessingSubmission(true);
        const isValid = validateFields(isSaveInstall);
        console.log('all fields valid', isValid);

        if (isValid === true) {
            const response = await fetch(Routes.Asset.CreateAsset(), {
                method: 'POST',
                headers: { ...postRequestHeaders },
                body: JSON.stringify(
                    mapFromAsset(isSaveInstall || isVirginOrRecoveryCylinder)
                )
            })

            setIsProcessingSubmission(false);

            const newdata = await response.json();

            if (response.status === 200) {
                setIsProcessingSubmission(false);
                setAssetId(newdata);

                if (parentAssetID) {
                    submitSubsystem(newdata, parentAssetID)
                } else {
                    if (id) {
                        toast.success("The inventory has been successfully edited.", { duration: 6000 });
                        navigate.goBack("/Inventory");
                    } else {
                        setSuccessfulPopup(true);
                    }
                }
            } else {
                setIsProcessingSubmission(false);

                if (Array.isArray(newdata) && newdata.length > 0) {
                    const { fieldErrors, globalErrors } = mapServerValidationErrorsToFields(newdata);

                    if (Object.keys(fieldErrors).length > 0) {
                        setErrorObject(prevErrors => ({ ...prevErrors, ...fieldErrors }));
                    }

                    if (globalErrors.length > 0) {
                        globalErrors.forEach(message => toast.error(message, { duration: 6000 }));
                    } else if (Object.keys(fieldErrors).length === 0) {
                        toast.error("There was an error saving the asset", { duration: 6000 });
                    }
                }
                else {
                    toast.error("There was an error saving the asset", { duration: 6000 });
                }
            }
        } else {
            setIsProcessingSubmission(false);
            toast.error('Please review the form for missing or incorrect fields', { duration: 6000 });
        }
    };

    const submitSubsystem = async (subsystemID, parentAssetID) => {
        var body = {
            "AssetRelationshipTypeID": 1,
            "FromAssetID": parentAssetID,
            "ToAssetID": subsystemID
        };
        const response = await fetch(Routes.Asset.CreateAssetRelationship(), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (response.status === 200) {
            if (activeRowState[assetType] !== true) {
                activeRowState[assetType] = true;
            }
            toast.success("The subsystem has been successfully created.", { duration: 6000 });
            sessionStorage.setItem("systemMapState", JSON.stringify(activeRowState));
            return navigate.push(
                `/Inventory/${parentAssetID}`, {
                state: { activeTab: activeTab, activeRowState: activeRowState }
            });
        } else {
            console.log('Error Response', response);
            return toast.error("Error Saving New Subsystem", { duration: 6000 });
        }
    };

    const GetAssetDropdownCodes = async function () {
        const response = await fetch(Routes.Asset.AddAssetDropdowns());
        const data = await response.json();

        return data;
    };

    const GetCurrentGasWeight = (isSaveInstall) => {

        if (isSaveInstall === false) {
            return 0
        } else {
            if (currentGasWeightOZ > 0) {
                return Weight.PoundToPoundOunce(currentGasWeightLBS, currentGasWeightOZ)
            } else {
                return currentGasWeightLBS
            }
        }
    };

    const GetGasCharge = () => {
        if (currentGasWeightOZ > 0) {
            return Weight.PoundToPoundOunce(chargeCapacityLBS, chargeCapacityOZ)
        } else {
            return chargeCapacityLBS
        }
    };

    const mapFromAsset = (isSaveInstall) => {
        return {
            id,
            location,
            subLocation,
            assetType,
            assetCategory,
            name,
            // assetStatus: isSaveInstall === false ? 2 : assetStatus,
            assetStatus: assetStatus,
            tagNumber,
            serialNumber,
            acquisitionDate: (acquisitionDate) ? FormatDate(acquisitionDate) : null,
            disbursementDate: (disbursementDate) ? FormatDate(disbursementDate) : null,
            installDate: (installDate) ? FormatDate(installDate) : null,
            LeakDetectionMonitorID: leakMonitorDevice,
            locationOnSite,
            manufacturer,
            manufactureDate: manufactureDate ? FormatDate(manufactureDate) : null,
            modelNumber,
            modelYear,
            brand,
            poNumber,
            lifeTime,
            systemType,
            generatorType,
            generatorSubtype,
            materialStatus,
            regulatedAssetTypes: regulatedAssetTypes.filter(x => regulatedAssets.filter(x => x !== -1).includes(x.value)).map(x => ({
                id: x.value,
                name: x.name
            })),
            // --------- Common Fields --------- \\

            // --------- Controls - Control --------- \\
            newPurchaseAquisition,

            // --------- Controls - Leak Monitoring Device --------- \\
            deviceType,
            aldType,
            detectionLimit,
            alarmPoint,
            concentrationMonitorType,
            concentrationMonitorManufacturer,
            sensorType,
            numberOfSensors,
            amps,
            voltage,
            hertz,
            phase,
            systemManager,
            hermeticallySealed,
            energySourceType,

            // --------- Fire Suppresion Systems --------- \\
            maxSuctionPressure,
            driverManufacturer,
            pumpModelNumber,
            maxShutoffPressure,
            driverModelNumber,
            pumpSerialNumber,
            ratedCapacity,
            driverRatedRPM,
            ratedRPM,
            ratedPressure,
            fuelTankCapacity,
            controllerManufacturer,
            oneFiftyRatedCapacity,
            controllerModelNumber,
            ratedPressureAtCapacity,
            controllerSerialNumber,
            materialType,
            smokeAlarmSubtype,
            sprinklerHeads,

            // --------- Heating Systems --------- \\
            heatingType,
            systemStatus: isSaveInstall === false ? 5 : systemStatus,
            //: isSaveInstall === false ? 5 : systemStatus,
            currentGasWeightLBS: GetCurrentGasWeight(isSaveInstall),
            //isSaveInstall === false ? 0 : currentGasWeightLBS,
            currentGasWeightOZ: isSaveInstall === false ? 0 : currentGasWeightOZ,
            ratedCoilTemperature,
            chargeCapacityLBS: GetGasCharge(),
            chargeCapacityOZ,
            chargeCapacityDeterminedBy,
            temperatureClass,
            coolingCapacity,
            SEER,
            EER,
            ESEER,
            oilType,
            alternateLeakDetectionMethod,
            leakDetectionDetails,

            // --------- Comfort Cooling --------- \\
            AssetSubType: assetSubtype ? assetSubtype : null,
            AssetKind: assetKind ? assetKind : null,

            // --------- Gas Recovery Cart --------- \\
            selfContained,
            certificationNotes,
            certificationDate,
            gasRecoveryCartId,

            // --------- Process Cooling --------- \\
            //AssetSubType: processCoolingType ? processCoolingType : null,
            //AssetKind: processCoolingSubType ? processCoolingSubType : null,
            ultraLowFreezerType,

            // --------- Cylinders --------- \\
            cylinderStatus,
            maxGasCapacity,
            dotExpirationDate,
            psiRating,
            currentPSI,
            boughtRented,

            // --------- Refrigeration Cooling --------- \\
            //AssetSubType: refigerationtCoolingType ? refigerationtCoolingType : null,
            //AssetKind: refrigerationSubtype ? refrigerationSubtype : null,
            //refigerationtCoolingType,
            //refrigerationSubtype,

            // --------- Septic Tank --------- \\
            septicTankType,

            // --------- Backflow Preventer --------- \\
            backflowPreventerType,
            backflowPreventerType2,
            installationDate,
            filterSize,
            oritentationType,
            waterOrigin,
            shutoffValveType,

            // --------- Plumbing / Fixtures --------- \\
            plumbingFixtureType,
            plumbingFixtureSubtypes,

            // --------- Water Cooling Tower Type --------- \\
            waterCoolingTowerType,
            waterCoolingTowerTypeSubOption,

            // --------- Water Heater Type --------- \\
            waterHeatersType,
            waterHeaterSubtype,
            capacityGallons,
            waterHeaterType,
            RequireInstall: isSaveInstall == true ? false : true
        }
    };

    const mapToAsset = (data) => {
        setAssetId(data.id);
        setApplianceId(data.applianceId);
        setCoolingApplianceId(data.coolingApplianceId);
        setLocation(data.location);
        setSubLocation(data.subLocation);
        setAssetType(data.assetType);
        setAssetCategory(data.assetCategory);
        setName(data.name);
        setAssetStatus(data.assetStatus);
        setTagNumber(data.tagNumber);
        setSerialNumber(data.serialNumber);
        setAquisitionDate(data.acquisitionDate);
        setDisbursementDate(data.disbursementDate);
        setInstallDate(data.installDate);
        setLocationOnsite(data.locationOnSite);
        setManufacturer(data.manufacturer);
        setManufactureDate(data.manufactureDate);
        setModelNumber(data.modelNumber);
        setModelYear(data.modelYear);
        setBrand(data.brand);
        setPONumber(data.poNumber);
        setLifeTime(data.lifeTime);
        setSystemType(data.systemType);
        setGeneratorType(data.generatorType);
        setGeneratorSubtype(data.generatorSubtype);
        setMaterialStatus(data.materialStatus);
        setRegulatedAssets((data.regulatedAssetTypes || [{ id: -1 }]).map(x => Number(x.id)));
        // --------- Common Fields --------- \\

        // --------- Controls - Control --------- \\
        setNewPurchaseAquisition(data.newPurchaseAquisition);

        // --------- Controls - Leak Monitoring Device --------- \\
        setDeviceType(data.deviceType);
        setALDType(data.aldType);
        setDetectionLimit(data.detectionLimit);
        setAlarmPoint(data.alarmPoint);
        setConcentrationMonitorType(data.concentrationMonitorType);
        setConcentrationMonitorManufacturer(data.concentrationMonitorManufacturer);
        setSensorType(data.sensorType);
        setNumberOfSensors(data.numberOfSensors);
        setAmps(data.amps);
        setVoltage(data.voltage);
        setHertz(data.hertz);
        setPhase(data.phase);
        setSystemManager(data.systemManager);
        setHermeticallySealed(data.hermeticallySealed == true ? 1 : data.hermeticallySealed == false ? 0 : null);
        setEnergySourceType(data.energySourceType);

        // --------- Fire Suppresion Systems --------- \\
        setMaxSuctionPressure(data.maxSuctionPressure);
        setDriverManufacturer(data.driverManufacturer);
        setPumpModelNumber(data.pumpModelNumber);
        setMaxShutoffPressure(data.maxShutoffPressure);
        setDriverModelNumber(data.driverModelNumber);
        setPumpSerialNumber(data.pumpSerialNumber);
        setRatedCapacity(data.ratedCapacity);
        setDriverRatedRPM(data.driverRatedRPM);
        setRatedRPM(data.ratedRPM);
        setRatedPressure(data.ratedPressure);
        setFuelTankCapacity(data.fuelTankCapacity);
        setControllerManufacturer(data.controllerManufacturer);
        setOneFiftyRatedCapacity(data.oneFiftyRatedCapacity);
        setControllerModelNumber(data.controllerModelNumber);
        setRatedPressureAtCapacity(data.ratedPressureAtCapacity);
        setControllerSerialNumber(data.controllerSerialNumber);
        setMaterialType(data.materialType);
        setSmokeAlarmSubtype(data.smokeAlarmSubtype);
        setSprinklerHeads(data.sprinklerHeads);

        // --------- Heating Systems --------- \\
        setHeatingType(data.heatingType);
        setSystemStatus(data.systemStatus);
        setCurrentGasWeightLBS(data.currentGasWeightLBS);
        setChargeCapacityLBS(data.chargeCapacityLBS);

        setRatedCoilTemperature(data.ratedCoilTemperature);
        //setChargeCapacityOZ(data.chargeCapacityOZ);


        setChargeCapacityDeterminedBy(data.chargeCapacityDeterminedBy);
        setTemperatureClass(data.temperatureClass);
        setCoolingCapacity(data.coolingCapacity);
        setSEER(data.seer);
        setEER(data.eer);
        setESEER(data.eseer);
        setOilType(getOilTypeValue(data.oilType));
        setAlternateLeakDetectionMethod(data.alternateLeakDetectionMethod);
        setLeakDetectionDetails(data.leakDetectionDetails);

        // --------- Comfort Cooling --------- \\
        //console.log(data.comfortCoolingType)
        setAssetSubtype(data.assetSubType);
        setAssetKind(data.assetKind);
        //setComfortCoolingSubOptions(data.comfortCoolingSubOptions);

        // --------- Gas Recovery Cart --------- \\
        setSelfContained((data.selfContained != null && data.selfContained == true) ? 1 : 0);
        setCertificationNotes(data.certificationNotes);
        setCertificationDate(data.certificationDate)
        setGasRecoveryCartId(data.gasRecoveryCartId)
        // --------- Process Cooling --------- \\
        setProcessCoolingType(data.assetSubType);
        setUltraLowFreezerType(data.ultraLowFreezerType);

        // --------- Cylinders --------- \\
        setCylinderStatus(data.cylinderStatus);
        setMaxGasCapacity(data.maxGasCapacity);
        setDotExpirationDate(data.dotExpirationDate);
        setPSIRating(data.psiRating);
        setCurrentPSI(data.currentPSI);
        setBoughtRented(data.boughtRented);

        // --------- Refrigeration Cooling --------- \\
        setRefrigerationCoolingType(data.assetSubType);
        setExtraOptions(yes_no_options);
        setRefrigerationSubtype(data.assetKind);

        // --------- Septic Tank --------- \\
        setSepticTankType(data.septicTankType);

        // --------- Backflow Preventer --------- \\
        setBackflowPreventerType(data.assetSubType);
        setBackflowPreventerType2(data.backflowPreventerType2);
        setInstallationDate(data.installationDate);
        setFilterSize(data.filterSize);
        setOritentationType(data.oritentationType);
        setWaterOrigin(data.waterOrigin);
        setShutoffValveType(data.shutoffValveType);

        // --------- Plumbing / Fixtures --------- \\
        setPlumbingFixtureType(data.plumbingFixtureType);
        setPlumbingFixtureSubtypes(data.plumbingFixtureSubtypes);

        // --------- Water Cooling Tower Type --------- \\
        setWaterCoolingTowerType(data.waterCoolingTowerType);
        setWaterCoolingTowerTypeSubOption(data.waterCoolingTowerTypeSubOption);

        // --------- Water Heater Type --------- \\
        setWaterHeatersType(data.waterHeatersType);
        setWaterHeaterSubtype(data.waterHeaterSubtype);
        setCapacityGallons(data.capacityGallons);
        setWaterHeaterType(data.waterHeaterType);
    };

    const mapCylinderData = (data, locations, returnData = false) => {
        const cylinder = { ...data };
        let regulatedAssets = [-1];

        setAssetType(cylinder.assetType);
        const location = locations.find(l => l.value === cylinder.location);
        const formattedAcquisitionDate = moment(cylinder.acquisitionDate).format('MM/DD/YYYY');
        const displayName = `${cylinder.name} • ${location.label} • ${formattedAcquisitionDate}`;
        // only when editing does name become a required field
        // also remove newPurchaseAquisition from being a required field on edit
        const requiredFields = [...editCylinderRequiredFields, 'name'];
        console.log('what does this look like', requiredFields);

        if (data.regulatedAssetTypes && data.regulatedAssetTypes.length) {
            regulatedAssets = data.regulatedAssetTypes.map(x => Number(x.id));
        }

        const cylinders = [{ open: true, displayName, ...cylinder, cylinderRequiredFields: requiredFields, cylinderTagSerialPair, regulatedAssets }];

        setCylinderState({ cylinders });
        if (returnData) return cylinder;
    };

    const closePage = () => {
        let defaultURL = "/Inventory";
        if (id) {
            defaultURL = `/Inventory/${id}`;
        } else if (parentAssetID) {
            defaultURL = `/Inventory/${parentAssetID}`;
        }

        navigate.goBack(defaultURL);
    };

    const deleteAsset = async () => {
        const response = await fetch(Routes.Asset.DeleteAsset(id), {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
        })

        if (response.status === 200) {
            toast.success("The Inventory has been successfully deleted.", { duration: 6000 });
            return navigate.push("/Inventory");
        } else {
            setShowDeleteModal(false);
            const errorData = await response.json();
            if (Array.isArray(errorData) && errorData[0] !== undefined) {
                return toast.error(errorData[0].exceptionMessage, { duration: 6000 });
            }
            return toast.error("Error Deleted Inventory", { duration: 6000 });
        }
    };

    const isDisableSystemType = () => {
        // logic for disable dropdown inventory type when it's not active and is not ComfortCooling, ProcessCooling or Refrigeration and not system admin or super tenantadmin
        return !(assetStatus === Enums.SE.AssetStatus.Active && (UserInfo.isSystemAdministrator() || UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator()) && EditableSystemType.includes(assetType)) && id;
    };

    const onAssetStatusChanged = (newAssetStatus) => {
        if (newAssetStatus === Enums.SE.AssetStatus.Active && (disbursementDate)) {
            return toast.error("The Asset Status cannot be set to 'Active' when a Disbursement Date is filled. Please update the Asset Status or clear the Disbursement Date.", { duration: 6000 });
        }

        setAssetStatus(newAssetStatus);
    }

    const handleExit = () => {
        // Asset type selected (minimum required field)
        if (!isEditing && assetType) return openExitModal();

        const dataToValidate = isVirginOrRecoveryCylinder ? cylinderState.cylinders[0] : mapFromAsset();
        if (isEditing && isDirty(dataToValidate)) return openExitModal();

        navigate.goBack();
    };

    const openExitModal = () => setExitModal(true);

    if (isAssetNotFound) {
        return <Error404/>
    }

    if (loading) {
        return <LoadingBar />;
    }

    return (
        <>
            <Box sx={{ pl: { xs: 2, sm: 0 }, pt: { xs: 2, sm: 0 } }}>
                {
                    parentAssetID ? (
                        <BreadCrumbs
                            path={[
                                { text: 'Inventory', to: `/Inventory` },
                                { text: `${parentAssetName}`, onClick: () => setExitModal(true) },
                                { text: `${id ? 'Edit' : 'Create'} Subsystem` }
                            ]}
                        />
                    ) : (
                        <BreadCrumbs
                            path={breadCrumb.getSortedBreadCrumbs()}
                        />
                    )
                }
            </Box>

            <Grid
                container
                sx={{
                    maxWidth: { xs: "100%", lg: "68%" },
                    ml: { xs: 0, lg: "26px" },
                    padding: { xs: 2, lg: 0 },
                }}
            >
                <Grid item xs={12} sx={{ paddingLeft: 0 }}>
                    <Grid container rowSpacing={3} sx={{ marginBottom: "20px" }}>
                        <Grid item xs={12} md={12} lg={12}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    flexDirection: "row",
                                    /*maxWidth: "calc(68% + 26px)",*/
                                    marginTop: isMobile ? "16px" : "0px",
                                    marginRight: "2%"
                                }}
                            >
                                <Box
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "center",
                                        flexDirection: "row",
                                    }}
                                >
                                    <IconButton aria-label="close" onClick={handleExit}>
                                        <CloseIcon />
                                    </IconButton>
                                    <Typography
                                        variant="h5"
                                        sx={{ "&.MuiTypography-root": { fontFamily: trakrefFontFamily } }}
                                        style={{ color: Grey1 }}
                                    >
                                        {!parentAssetID ? pageHeader : subSystemHeader}
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid
                            container
                            item
                            xs={12}
                            pt={2}
                            columnSpacing={{ xs: 0, sm: 2 }}
                            rowSpacing={2}
                        >
                            <Grid item xs={12} sm={6} md={6} lg={6}>
                                <Select
                                    value={assetType}
                                    label="Inventory Type"
                                    options={assetTypes}
                                    onChange={e => {
                                        const { value } = e.target;
                                        const assetType = assetTypes.find(f => f.id === value)

                                        setAssetType(value);
                                        setAssetCategory(assetType ? assetType.assetCategoryId : "");
                                        // Set "DisplayName" for cylinder
                                        if ([Enums.AssetTypes.VirginCylinder, Enums.AssetTypes.RecoveryCylinder].includes(value)) {
                                            const displayName = value === Enums.AssetTypes.RecoveryCylinder ? 'Rec' : 'Virgin'
                                            setCylinderState({
                                                cylinders: [{ ...cylinderState.cylinders[0], displayName }]
                                            });
                                        }
                                        resetFields();
                                    }}
                                    disabled={isDisableSystemType()}
                                />
                            </Grid>
                            {assetType === 9 && (
                                <ControlsControl
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    assetStatusTypes={assetStatusTypes}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    ErrorObject={ErrorObject}
                                    id={assetId}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === Enums.AssetTypes.LeakMonitoringDevice && (
                                <ControlsLeakMonitoringDevice
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    deviceType={deviceType}
                                    setDeviceType={setDeviceType}
                                    aldType={aldType}
                                    setALDType={setALDType}
                                    detectionLimit={detectionLimit}
                                    setDetectionLimit={setDetectionLimit}
                                    alarmPoint={alarmPoint}
                                    setAlarmPoint={setAlarmPoint}
                                    concentrationMonitorType={concentrationMonitorType}
                                    setConcentrationMonitorType={setConcentrationMonitorType}
                                    concentrationMonitorManufacturer={concentrationMonitorManufacturer}
                                    setConcentrationMonitorManufacturer={setConcentrationMonitorManufacturer}
                                    sensorType={sensorType}
                                    setSensorType={setSensorType}
                                    numberOfSensors={numberOfSensors}
                                    setNumberOfSensors={setNumberOfSensors}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    maxDate={maxDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    systemManagers={systemManagers}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    errorObject={ErrorObject}
                                    id={assetId}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 13 && (
                                <Generator
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    generatorType={generatorType}
                                    setGeneratorType={setGeneratorType}
                                    generatorSubtype={generatorSubtype}
                                    setGeneratorSubtype={setGeneratorSubtype}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 99 && (
                                <DieselFirePump
                                    locations={locations}
                                    manufacturers={manufacturers}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    maxSuctionPressure={maxSuctionPressure}
                                    setMaxSuctionPressure={setMaxSuctionPressure}
                                    driverManufacturer={driverManufacturer}
                                    setDriverManufacturer={setDriverManufacturer}
                                    pumpModelNumber={pumpModelNumber}
                                    setPumpModelNumber={setPumpModelNumber}
                                    maxShutoffPressure={maxShutoffPressure}
                                    setMaxShutoffPressure={setMaxShutoffPressure}
                                    driverModelNumber={driverModelNumber}
                                    setDriverModelNumber={setDriverModelNumber}
                                    pumpSerialNumber={pumpSerialNumber}
                                    setPumpSerialNumber={setPumpSerialNumber}
                                    ratedCapacity={ratedCapacity}
                                    setRatedCapacity={setRatedCapacity}
                                    driverRatedRPM={driverRatedRPM}
                                    setDriverRatedRPM={setDriverRatedRPM}
                                    ratedRPM={ratedRPM}
                                    setRatedRPM={setRatedRPM}
                                    ratedPressure={ratedPressure}
                                    setRatedPressure={setRatedPressure}
                                    fuelTankCapacity={fuelTankCapacity}
                                    setFuelTankCapacity={setFuelTankCapacity}
                                    controllerManufacturer={controllerManufacturer}
                                    setControllerManufacturer={setControllerManufacturer}
                                    oneFiftyRatedCapacity={oneFiftyRatedCapacity}
                                    setOneFiftyRatedCapacity={setOneFiftyRatedCapacity}
                                    controllerModelNumber={controllerModelNumber}
                                    setControllerModelNumber={setControllerModelNumber}
                                    ratedPressureAtCapacity={ratedPressureAtCapacity}
                                    setRatedPressureAtCapacity={setRatedPressureAtCapacity}
                                    controllerSerialNumber={controllerSerialNumber}
                                    setControllerSerialNumber={setControllerSerialNumber}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 5 && (
                                <FireExtingusiher
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    materialType={materialType}
                                    setMaterialType={setMaterialType}
                                    locations={locations}
                                    manufacturers={manufacturers}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    maxSuctionPressure={maxSuctionPressure}
                                    setMaxSuctionPressure={setMaxSuctionPressure}
                                    driverManufacturer={driverManufacturer}
                                    setDriverManufacturer={setDriverManufacturer}
                                    pumpModelNumber={pumpModelNumber}
                                    setPumpModelNumber={setPumpModelNumber}
                                    maxShutoffPressure={maxShutoffPressure}
                                    setMaxShutoffPressure={setMaxShutoffPressure}
                                    driverModelNumber={driverModelNumber}
                                    setDriverModelNumber={setDriverModelNumber}
                                    pumpSerialNumber={pumpSerialNumber}
                                    setPumpSerialNumber={setPumpSerialNumber}
                                    ratedCapacity={ratedCapacity}
                                    setRatedCapacity={setRatedCapacity}
                                    driverRatedRPM={driverRatedRPM}
                                    setDriverRatedRPM={setDriverRatedRPM}
                                    ratedRPM={ratedRPM}
                                    setRatedRPM={setRatedRPM}
                                    ratedPressure={ratedPressure}
                                    setRatedPressure={setRatedPressure}
                                    fuelTankCapacity={fuelTankCapacity}
                                    setFuelTankCapacity={setFuelTankCapacity}
                                    controllerManufacturer={controllerManufacturer}
                                    setControllerManufacturer={setControllerManufacturer}
                                    oneFiftyRatedCapacity={oneFiftyRatedCapacity}
                                    setOneFiftyRatedCapacity={setOneFiftyRatedCapacity}
                                    controllerModelNumber={controllerModelNumber}
                                    setControllerModelNumber={setControllerModelNumber}
                                    ratedPressureAtCapacity={ratedPressureAtCapacity}
                                    setRatedPressureAtCapacity={setRatedPressureAtCapacity}
                                    controllerSerialNumber={controllerSerialNumber}
                                    setControllerSerialNumber={setControllerSerialNumber}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 6 && (
                                <SmokeAlarm
                                    smokeAlarmSubtype={smokeAlarmSubtype}
                                    setSmokeAlarmSubtype={setSmokeAlarmSubtype}
                                    locations={locations}
                                    manufacturers={manufacturers}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    maxSuctionPressure={maxSuctionPressure}
                                    setMaxSuctionPressure={setMaxSuctionPressure}
                                    driverManufacturer={driverManufacturer}
                                    setDriverManufacturer={setDriverManufacturer}
                                    pumpModelNumber={pumpModelNumber}
                                    setPumpModelNumber={setPumpModelNumber}
                                    maxShutoffPressure={maxShutoffPressure}
                                    setMaxShutoffPressure={setMaxShutoffPressure}
                                    driverModelNumber={driverModelNumber}
                                    setDriverModelNumber={setDriverModelNumber}
                                    pumpSerialNumber={pumpSerialNumber}
                                    setPumpSerialNumber={setPumpSerialNumber}
                                    ratedCapacity={ratedCapacity}
                                    setRatedCapacity={setRatedCapacity}
                                    driverRatedRPM={driverRatedRPM}
                                    setDriverRatedRPM={setDriverRatedRPM}
                                    ratedRPM={ratedRPM}
                                    setRatedRPM={setRatedRPM}
                                    ratedPressure={ratedPressure}
                                    setRatedPressure={setRatedPressure}
                                    fuelTankCapacity={fuelTankCapacity}
                                    setFuelTankCapacity={setFuelTankCapacity}
                                    controllerManufacturer={controllerManufacturer}
                                    setControllerManufacturer={setControllerManufacturer}
                                    oneFiftyRatedCapacity={oneFiftyRatedCapacity}
                                    setOneFiftyRatedCapacity={setOneFiftyRatedCapacity}
                                    controllerModelNumber={controllerModelNumber}
                                    setControllerModelNumber={setControllerModelNumber}
                                    ratedPressureAtCapacity={ratedPressureAtCapacity}
                                    setRatedPressureAtCapacity={setRatedPressureAtCapacity}
                                    controllerSerialNumber={controllerSerialNumber}
                                    setControllerSerialNumber={setControllerSerialNumber}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 7 && (
                                <SprinklerHeads
                                    sprinklerHeads={sprinklerHeads}
                                    setSprinklerHeads={setSprinklerHeads}
                                    locations={locations}
                                    manufacturers={manufacturers}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    maxSuctionPressure={maxSuctionPressure}
                                    setMaxSuctionPressure={setMaxSuctionPressure}
                                    driverManufacturer={driverManufacturer}
                                    setDriverManufacturer={setDriverManufacturer}
                                    pumpModelNumber={pumpModelNumber}
                                    setPumpModelNumber={setPumpModelNumber}
                                    maxShutoffPressure={maxShutoffPressure}
                                    setMaxShutoffPressure={setMaxShutoffPressure}
                                    driverModelNumber={driverModelNumber}
                                    setDriverModelNumber={setDriverModelNumber}
                                    pumpSerialNumber={pumpSerialNumber}
                                    setPumpSerialNumber={setPumpSerialNumber}
                                    ratedCapacity={ratedCapacity}
                                    setRatedCapacity={setRatedCapacity}
                                    driverRatedRPM={driverRatedRPM}
                                    setDriverRatedRPM={setDriverRatedRPM}
                                    ratedRPM={ratedRPM}
                                    setRatedRPM={setRatedRPM}
                                    ratedPressure={ratedPressure}
                                    setRatedPressure={setRatedPressure}
                                    fuelTankCapacity={fuelTankCapacity}
                                    setFuelTankCapacity={setFuelTankCapacity}
                                    controllerManufacturer={controllerManufacturer}
                                    setControllerManufacturer={setControllerManufacturer}
                                    oneFiftyRatedCapacity={oneFiftyRatedCapacity}
                                    setOneFiftyRatedCapacity={setOneFiftyRatedCapacity}
                                    controllerModelNumber={controllerModelNumber}
                                    setControllerModelNumber={setControllerModelNumber}
                                    ratedPressureAtCapacity={ratedPressureAtCapacity}
                                    setRatedPressureAtCapacity={setRatedPressureAtCapacity}
                                    controllerSerialNumber={controllerSerialNumber}
                                    setControllerSerialNumber={setControllerSerialNumber}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 21 && (
                                <GeneralInventory
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 66 && (
                                <Heating
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    heatingType={heatingType}
                                    setHeatingType={setHeatingType}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    materialType={materialType}
                                    setMaterialType={setMaterialType}
                                    systemStatus={systemStatus}
                                    setSystemStatus={setSystemStatus}
                                    currentGasWeightLBS={currentGasWeightLBS}
                                    setCurrentGasWeightLBS={setCurrentGasWeightLBS}
                                    currentGasWeightOZ={currentGasWeightOZ}
                                    setCurrentGasWeightOZ={setCurrentGasWeightOZ}
                                    ratedCoilTemperature={ratedCoilTemperature}
                                    setRatedCoilTemperature={setRatedCoilTemperature}
                                    chargeCapacityLBS={chargeCapacityLBS}
                                    setChargeCapacityLBS={setChargeCapacityLBS}
                                    chargeCapacityOZ={chargeCapacityOZ}
                                    setChargeCapacityOZ={setChargeCapacityOZ}
                                    chargeCapacityDeterminedBy={chargeCapacityDeterminedBy}
                                    setChargeCapacityDeterminedBy={setChargeCapacityDeterminedBy}
                                    temperatureClass={temperatureClass}
                                    setTemperatureClass={setTemperatureClass}
                                    coolingCapacity={coolingCapacity}
                                    setCoolingCapacity={setCoolingCapacity}
                                    SEER={SEER}
                                    setSEER={setSEER}
                                    EER={EER}
                                    setEER={setEER}
                                    ESEER={ESEER}
                                    setESEER={setESEER}
                                    oilType={oilType}
                                    setOilType={setOilType}
                                    alternateLeakDetectionMethod={alternateLeakDetectionMethod}
                                    setAlternateLeakDetectionMethod={setAlternateLeakDetectionMethod}
                                    leakDetectionDetails={leakDetectionDetails}
                                    setLeakDetectionDetails={setLeakDetectionDetails}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManagers={systemManagers}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === Enums.AssetTypes.ComfortCooling && (
                                <ComfortCooling
                                    materialTypes={materialTypes}
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={onAssetStatusChanged}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    systemType={systemType}
                                    setSystemType={setSystemType}
                                    comfortCoolingType={assetSubtype}
                                    setComfortCoolingType={setAssetSubtype}
                                    comfortCoolingSubtype={assetKind}
                                    setComfortCoolingSubtype={setAssetKind}
                                    comfortCoolingSubOptions={comfortCoolingSubOptions}
                                    setComfortCoolingSubOptions={setComfortCoolingSubOptions}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    materialType={materialType}
                                    setMaterialType={setMaterialType}
                                    systemStatus={systemStatus}
                                    setSystemStatus={setSystemStatus}
                                    currentGasWeightLBS={currentGasWeightLBS}
                                    setCurrentGasWeightLBS={setCurrentGasWeightLBS}
                                    currentGasWeightOZ={currentGasWeightOZ}
                                    setCurrentGasWeightOZ={setCurrentGasWeightOZ}
                                    ratedCoilTemperature={ratedCoilTemperature}
                                    setRatedCoilTemperature={setRatedCoilTemperature}
                                    chargeCapacityLBS={chargeCapacityLBS}
                                    setChargeCapacityLBS={setChargeCapacityLBS}
                                    chargeCapacityOZ={chargeCapacityOZ}
                                    setChargeCapacityOZ={setChargeCapacityOZ}
                                    chargeCapacityDeterminedBy={chargeCapacityDeterminedBy}
                                    setChargeCapacityDeterminedBy={setChargeCapacityDeterminedBy}
                                    temperatureClass={temperatureClass}
                                    setTemperatureClass={setTemperatureClass}
                                    coolingCapacity={coolingCapacity}
                                    setCoolingCapacity={setCoolingCapacity}
                                    SEER={SEER}
                                    setSEER={setSEER}
                                    EER={EER}
                                    setEER={setEER}
                                    ESEER={ESEER}
                                    setESEER={setESEER}
                                    oilType={oilType}
                                    setOilType={setOilType}
                                    alternateLeakDetectionMethod={alternateLeakDetectionMethod}
                                    setAlternateLeakDetectionMethod={setAlternateLeakDetectionMethod}
                                    leakDetectionDetails={leakDetectionDetails}
                                    setLeakDetectionDetails={setLeakDetectionDetails}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManagers={systemManagers}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    ErrorObject={ErrorObject}
                                    leakMonitorDevice={leakMonitorDevice}
                                    setLeakMonitorDevice={setLeakMonitorDevice}
                                    id={assetId}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 67 && (
                                <GasRecoveryCart
                                    materialTypes={materialTypes}
                                    materialType={materialType}
                                    setMaterialType={setMaterialType}
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    selfContained={selfContained}
                                    setSelfContained={setSelfContained}
                                    certificationNotes={certificationNotes}
                                    setCertificationNotes={setCertificationNotes}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    certificationDate={certificationDate}
                                    setCertificationDate={setCertificationDate}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManagers={systemManagers}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    maxDate={maxDate}
                                    id={assetId}
                                    ErrorObject={ErrorObject}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 63 && (
                                <ProcessCooling
                                    materialTypes={materialTypes}
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={onAssetStatusChanged}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    systemType={systemType}
                                    setSystemType={setSystemType}
                                    processCoolingType={assetSubtype}
                                    setProcessCoolingType={setAssetSubtype}
                                    ultraLowFreezerType={assetKind}
                                    setUltraLowFreezerType={setAssetKind}
                                    comfortCoolingSubOptions={comfortCoolingSubOptions}
                                    setComfortCoolingSubOptions={setComfortCoolingSubOptions}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    materialType={materialType}
                                    setMaterialType={setMaterialType}
                                    systemStatus={systemStatus}
                                    setSystemStatus={setSystemStatus}
                                    currentGasWeightLBS={currentGasWeightLBS}
                                    setCurrentGasWeightLBS={setCurrentGasWeightLBS}
                                    currentGasWeightOZ={currentGasWeightOZ}
                                    setCurrentGasWeightOZ={setCurrentGasWeightOZ}
                                    ratedCoilTemperature={ratedCoilTemperature}
                                    setRatedCoilTemperature={setRatedCoilTemperature}
                                    chargeCapacityLBS={chargeCapacityLBS}
                                    setChargeCapacityLBS={setChargeCapacityLBS}
                                    chargeCapacityOZ={chargeCapacityOZ}
                                    setChargeCapacityOZ={setChargeCapacityOZ}
                                    chargeCapacityDeterminedBy={chargeCapacityDeterminedBy}
                                    setChargeCapacityDeterminedBy={setChargeCapacityDeterminedBy}
                                    temperatureClass={temperatureClass}
                                    setTemperatureClass={setTemperatureClass}
                                    coolingCapacity={coolingCapacity}
                                    setCoolingCapacity={setCoolingCapacity}
                                    SEER={SEER}
                                    setSEER={setSEER}
                                    EER={EER}
                                    setEER={setEER}
                                    ESEER={ESEER}
                                    setESEER={setESEER}
                                    oilType={oilType}
                                    setOilType={setOilType}
                                    alternateLeakDetectionMethod={alternateLeakDetectionMethod}
                                    setAlternateLeakDetectionMethod={setAlternateLeakDetectionMethod}
                                    leakDetectionDetails={leakDetectionDetails}
                                    setLeakDetectionDetails={setLeakDetectionDetails}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManagers={systemManagers}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    ErrorObject={ErrorObject}
                                    ExtraOptions={extraOptions}
                                    setExtraOptions={setExtraOptions}
                                    processCoolingSubType={processCoolingSubType}
                                    setProcessCoolingSubType={setProcessCoolingSubType}
                                    leakMonitorDevice={leakMonitorDevice}
                                    setLeakMonitorDevice={setLeakMonitorDevice}
                                    id={assetId}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {isVirginOrRecoveryCylinder && (
                                <Cylinder
                                    cylinderState={cylinderState}
                                    cylinderErrorState={cylinderErrorState}
                                    setCylinderState={setCylinderState}
                                    validateCylinderFields={validateCylinderFields}
                                    locations={locations}
                                    assetType={assetType}
                                    acquireLocationOptions={aquireLocationOptions}
                                    materialTypes={materialTypes}
                                    materialStatuses={assetType == Enums.AssetTypes.RecoveryCylinder ? materialStatuses.filter(ms => ms.label !== 'Virgin') : materialStatuses.filter(ms => (ms.label == 'Virgin' || ms.label == "Unknown"))}
                                    //materialStatuses={materialStatuses.filter(ms => ms.label !== 'Virgin')} // Recovery Cylinder does not get Virgin option - filter out
                                    cylinderStatus={cylinderStatus}
                                    psiRatings={psiRatings}
                                    manufacturers={manufacturers}
                                    years={years}
                                    lifeTimeOptions={lifeTimeOptions}
                                    id={assetId}
                                    maxDate={maxDate}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    defaultLocationId={parentAssetLocationID}
                                />
                            )}
                            {assetType === 22 && (
                                <Refrigeration
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={onAssetStatusChanged}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    systemType={systemType}
                                    setSystemType={setSystemType}
                                    refigerationtCoolingType={assetSubtype}
                                    setRefrigerationCoolingType={setAssetSubtype}
                                    extraOptions={extraOptions}
                                    setExtraOptions={setExtraOptions}
                                    refrigerationSubtype={assetKind}
                                    setRefrigerationSubtype={setAssetKind}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    materialType={materialType}
                                    setMaterialType={setMaterialType}
                                    materialTypes={materialTypes}
                                    systemStatus={systemStatus}
                                    setSystemStatus={setSystemStatus}
                                    currentGasWeightLBS={currentGasWeightLBS}
                                    setCurrentGasWeightLBS={setCurrentGasWeightLBS}
                                    currentGasWeightOZ={currentGasWeightOZ}
                                    setCurrentGasWeightOZ={setCurrentGasWeightOZ}
                                    ratedCoilTemperature={ratedCoilTemperature}
                                    setRatedCoilTemperature={setRatedCoilTemperature}
                                    chargeCapacityLBS={chargeCapacityLBS}
                                    setChargeCapacityLBS={setChargeCapacityLBS}
                                    chargeCapacityOZ={chargeCapacityOZ}
                                    setChargeCapacityOZ={setChargeCapacityOZ}
                                    chargeCapacityDeterminedBy={chargeCapacityDeterminedBy}
                                    setChargeCapacityDeterminedBy={setChargeCapacityDeterminedBy}
                                    temperatureClass={temperatureClass}
                                    setTemperatureClass={setTemperatureClass}
                                    coolingCapacity={coolingCapacity}
                                    setCoolingCapacity={setCoolingCapacity}
                                    SEER={SEER}
                                    setSEER={setSEER}
                                    EER={EER}
                                    setEER={setEER}
                                    ESEER={ESEER}
                                    setESEER={setESEER}
                                    oilType={oilType}
                                    setOilType={setOilType}
                                    alternateLeakDetectionMethod={alternateLeakDetectionMethod}
                                    setAlternateLeakDetectionMethod={setAlternateLeakDetectionMethod}
                                    leakDetectionDetails={leakDetectionDetails}
                                    setLeakDetectionDetails={setLeakDetectionDetails}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManagers={systemManagers}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    leakMonitorDevice={leakMonitorDevice}
                                    setLeakMonitorDevice={setLeakMonitorDevice}
                                    ErrorObject={ErrorObject}
                                    id={assetId}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 16 && (
                                <GreaseTrap
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 17 && (
                                <SepticTank
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    septicTankType={septicTankType}
                                    setSepticTankType={setSepticTankType}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {(isSubsystem(assetType)) && ( // Evaporator, condensor and compressorRack come from Subsystem
                                <Subsystem
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    aquireLocationsOptions={aquireLocationOptions}
                                    aquireLocation={aquireLocation}
                                    setAquireLocation={setAquireLocation}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocationOptions={subLocations}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    id={assetId}
                                    ErrorObject={ErrorObject}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 20 && (
                                <DecorativeFountain
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 26 && (
                                <EyeWashStation
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    amps={amps}
                                    setAmps={setAmps}
                                    voltage={voltage}
                                    setVoltage={setVoltage}
                                    hertz={hertz}
                                    setHertz={setHertz}
                                    phase={phase}
                                    setPhase={setPhase}
                                    systemManagers={systemManagers}
                                    systemManager={systemManager}
                                    setSystemManager={setSystemManager}
                                    hermeticallySealed={hermeticallySealed}
                                    setHermeticallySealed={setHermeticallySealed}
                                    energySourceType={energySourceType}
                                    setEnergySourceType={setEnergySourceType}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 14 && (
                                <PlumbingFixtures
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    plumbingFixtureType={plumbingFixtureType}
                                    setPlumbingFixtureType={setPlumbingFixtureType}
                                    plumbingFixtureSubtypes={plumbingFixtureSubtypes}
                                    setPlumbingFixtureSubtypes={setPlumbingFixtureSubtypes}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 23 && (
                                <WaterCoolingTower
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    waterCoolingTowerType={waterCoolingTowerType}
                                    setWaterCoolingTowerType={setWaterCoolingTowerType}
                                    waterCoolingTowerTypeSubOption={waterCoolingTowerTypeSubOption}
                                    setWaterCoolingTowerTypeSubOption={setWaterCoolingTowerTypeSubOption}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                            {assetType === 24 && (
                                <WaterHeaters
                                    newPurchaseAquisition={newPurchaseAquisition}
                                    setNewPurchaseAquisition={setNewPurchaseAquisition}
                                    locations={locations}
                                    location={location}
                                    setLocation={setLocation}
                                    subLocation={subLocation}
                                    setSubLocation={setSubLocation}
                                    name={name}
                                    setName={setName}
                                    assetStatus={assetStatus}
                                    setAssetStatus={setAssetStatus}
                                    tagNumber={tagNumber}
                                    setTagNumber={setTagNumber}
                                    serialNumber={serialNumber}
                                    setSerialNumber={setSerialNumber}
                                    waterHeatersType={waterHeatersType}
                                    setWaterHeatersType={setWaterHeatersType}
                                    waterHeaterSubtype={waterHeaterSubtype}
                                    setWaterHeaterSubtype={setWaterHeaterSubtype}
                                    acquisitionDate={acquisitionDate}
                                    setAquisitionDate={setAquisitionDate}
                                    disbursementDate={disbursementDate}
                                    setDisbursementDate={setDisbursementDate}
                                    installDate={installDate}
                                    setInstallDate={setInstallDate}
                                    capacityGallons={capacityGallons}
                                    setCapacityGallons={setCapacityGallons}
                                    waterHeaterType={waterHeaterType}
                                    setWaterHeaterType={setWaterHeaterType}
                                    locationOnSite={locationOnSite}
                                    setLocationOnsite={setLocationOnsite}
                                    manufacturer={manufacturer}
                                    setManufacturer={setManufacturer}
                                    manufacturers={manufacturers}
                                    manufactureDate={manufactureDate}
                                    setManufactureDate={setManufactureDate}
                                    modelNumber={modelNumber}
                                    setModelNumber={setModelNumber}
                                    modelYear={modelYear}
                                    setModelYear={setModelYear}
                                    years={years}
                                    brand={brand}
                                    setBrand={setBrand}
                                    poNumber={poNumber}
                                    setPONumber={setPONumber}
                                    lifeTime={lifeTime}
                                    setLifeTime={setLifeTime}
                                    lifeTimeOptions={lifeTimeOptions}
                                    maxDate={maxDate}
                                    regulatedAssets={regulatedAssets}
                                    regulatedAssetTypes={regulatedAssetTypes}
                                    setRegulatedAssets={setRegulatedAssets}
                                />
                            )}
                        </Grid>
                        {
                            assetType && (
                                <Grid item xs={12} mb={4} sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'flex-end', gap: 1.5 }}>
                                    {renderDeleteButton && (
                                        <SecondaryButton
                                            buttonText='Delete'
                                            onClick={() => setShowDeleteModal(true)}
                                            sx={{ height: 42, width: { xs: '100%', sm: 140 } }}
                                        />
                                    )}
                                    {renderSecondaryButton && canSaveInstalled && !isVirginOrRecoveryCylinder && (
                                        (isProcessingSubmission === false && canSaveInstalled) ? (
                                            <SecondaryButton
                                                buttonText='Save Installed'
                                                onClick={() => submit(true)}
                                                disabled={assetType === ''}
                                                sx={{ height: 42, width: { xs: '100%', sm: 160, md: 200 } }}
                                            />
                                        ) : (
                                            <LoadingButton loading variant="outlined" sx={{ height: 42, width: { xs: '100%', sm: 160, md: 200 } }}>
                                                <span>Submit</span>
                                            </LoadingButton>
                                        )
                                    )}
                                    <LoadingButtonV4
                                        buttonText={id ? 'Save' : (!parentAssetID ? 'Create Inventory' : 'Create Subsystem')}
                                        loading={loading || isProcessingSubmission}
                                        onClick={() => submit(!!id)}
                                        sx={{ height: 42, width: { xs: '100%', sm: 140, md: 200 } }}
                                    />
                                </Grid>
                            )
                        }
                    </Grid>
                </Grid>
            </Grid>

            <CommonModal
                open={successfulPopup}
                close={() => navigate.goBack("/Inventory")}
            >
                <Grid container>
                    <Grid item xs={12} lg={12} align='center'>
                        <img
                            style={{ paddingBottom: '4%' }}
                            src={'/images/Asset_Create_Img.svg'}
                            width="225.92px"
                            height="192.82px"
                            alt='Asset Successfully Created'
                        />
                    </Grid>
                    <Grid item xs={12} align='center'>
                        <Typography
                            variant="h5"
                            sx={{ '&.MuiTypography-root': { fontFamily: trakrefFontFamily } }}
                            style={{ marginBottom: '6%', color: Grey2 }}
                            align='center'
                        >
                            {(!id) ? "Inventory successfully created." : "Inventory successfully updated."}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} align='center' sx={{ marginBottom: '4%' }}>
                        <PrimaryButton
                            width={70}
                            useLargeButton
                            buttonText='VIEW INVENTORY DETAILS'
                            onClick={() => navigate.push(`/Inventory/${assetId}`, { replace: true })}
                        />
                    </Grid>
                    <Grid item xs={12} align='center' sx={{ marginBottom: '4%' }}>
                        <SecondaryButton
                            useLargeButton
                            width={70}
                            onClick={() => window.location.reload()}
                            buttonText='CREATE NEW INVENTORY'
                        />
                    </Grid>
                </Grid>
            </CommonModal>

            <ExitConfirmationModal
                open={exitModal}
                close={() => setExitModal(false)}
                leaveOnClick={closePage}
                stayOnClick={() => setExitModal(false)}
                isEditing={isEditing}
            />

            <DeleteModal
                open={showDeleteModal}
                buttonText={"Yes, Delete"}
                title="Delete Inventory?"
                description="Are you sure you want to delete this inventory?"
                onClose={() => setShowDeleteModal(false)}
                onConfirm={deleteAsset}
            />
        </>

    );
};

export default AddAsset;
